import { polygonOnDragEndAction } from '../functions/events/polygonOnDragEndAction';
import 'leaflet.path.drag';

export function enableDragging(
    featureGroupRef: React.MutableRefObject<null>,
    multiPolygonEditedIdState: number,
    measuringToolIds: any,
) {
    //@ts-ignore
    if (featureGroupRef && featureGroupRef.current && featureGroupRef.current._layers) {
        //@ts-ignore
        let layers = Object.values(featureGroupRef.current._layers);
        layers.map((layer: any) => {
            let isMeasuringTool = false;
            measuringToolIds &&
                measuringToolIds.length > 0 &&
                measuringToolIds.map((id: any) => {
                    if (layer._leaflet_id === id) isMeasuringTool = true;
                });
            if (!isMeasuringTool) {
                layer.dragging.enable();
                layer.on('dragend', (e: any) => {
                    polygonOnDragEndAction(e);
                });
            }
        });
        // } else {
        //     if (layers) {
        //         layers.map((layer: any) => layer.dragging.disable());
        //     }
        // }
    }
}
